import { setValue } from 'gisw/Helpers/storage';

import screenSizeWarningTemplate from './ScreenSizeWarning.html';

/**
 * @param {string} message
 */
function screenSizeWarning (message) {
  const screenWarningId = '#ScreenSizeWarning';
  const screenWarningModalId = '#ScreenSizeWarningModal';
  const disableCheckboxId = '#ScreenWarningDisable';
  const screenWarningTitle = '#screenWarningTitle';
  const screenWarningBodyText = '#ScreenWarningBodyText';

  if ($(screenWarningId).length === 0) {
    const [screenSizeWarningModal] = $.parseHTML(screenSizeWarningTemplate);
    document.body.appendChild(screenSizeWarningModal);

    // Saves disable flag
    $(disableCheckboxId).on('change', event => {
      // @ts-ignore
      setValue('disableSizeWarning', event.target.checked);
    });

    $(screenWarningModalId).on('hide.bs.modal', function () {
      // @ts-ignore
      $(disableCheckboxId).get(0).checked = false;
    });
  } else if (
    // @ts-ignore
    $(disableCheckboxId).get(0).checked
  ) {
    $(screenWarningModalId).modal('hide');
    return;
  }

  // Fill template and open modal
  $(screenWarningTitle).html('Screen Size Warning');
  $(screenWarningBodyText).html(message);
  $(screenWarningModalId).modal('show');
}

export default screenSizeWarning;
